import { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import AddFee from "./AddFee";
import FeesTable from "./FeesTable";
import { getSchoolFees } from "../../../ApiService/ApiService";
import { Add } from "@mui/icons-material";

function FeesSection() {
  const schoolId = sessionStorage.getItem("schoolId");
  const [showAddFees, setShowAddFees] = useState(false);
  const [feesDetails, setFeesDetails] = useState({});

  const fetchSchoolFeesDetails = async () => {
    try {
      const response = await getSchoolFees(schoolId);
      // console.log("RES", response?.data);
      setFeesDetails(response?.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    fetchSchoolFeesDetails();
  }, [schoolId]);

  const renderMainContent = () => {
    if (showAddFees) {
      return (
        <AddFee
          setShowAddFees={setShowAddFees}
          fetchSchoolFeesDetails={fetchSchoolFeesDetails}
        />
      );
    } else {
      return <FeesTable feesDetails={feesDetails} />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: showAddFees ? "none" : "flex",
          justifyContent: "space-between",
        }}
      >
        <Typography
          paragraph
          sx={{ color: "black", fontSize: 22, fontWeight: 600 }}
          xs={4}
          sm={4}
          md={6}
          lg={8}
          xl={8}
        >
          Fees Section
        </Typography>
        <Button
          xs={8}
          sm={8}
          md={6}
          lg={4}
          xl={4}
          onClick={() => setShowAddFees(true)}
          variant="contained"
          color="primary"
          size="small"
          sx={{
            mb: 2,
            textTransform: "unset",
            borderRadius: 2,
          }}
        >
          <Add fontSize="small" />
          Add Fee
        </Button>
      </Box>
      {renderMainContent()}
    </>
  );
}

export default FeesSection;
